import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ICarrierBranchResponseDTO, ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';

export class GetAllBranchesV2Command extends IRequestCommand<ICarrierBranchResponseDTO[], ErrorDetails, IGetAllBranchesV2CommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierAccountId}/branches';

  public override setParameters(parameters: IGetAllBranchesV2CommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierAccountId}',
      parameters.carrierId.toString()
    );
  }
}

export interface IGetAllBranchesV2CommandParameters {
  carrierId: number;
}
